import { format, InputMask } from "@react-input/mask";
import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";

interface Props {
  id: any;
  value: any;
  setCustomerData?: any;
  setIsInvalid?: any;
  className: any;
  setShowModal: any;
  disable: any;
}

const InputPfPj: React.FC<Props> = ({ id, value, setCustomerData, setShowModal, className, setIsInvalid, disable}) => {
  const [loading, setLoading] = useState(false)
  const [label, setLabel] = useState(<label>Informe CPF do <b>Cliente</b></label>)
  const [valueClean, setValueClean] = useState("")
  const [masked, setMasked] = useState("___.___.___-__")
  const [maskedValue, setMaskedValue] = useState("")
  const [invalidFeedBack, setInvalidFeedBack] = useState("")

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target

    setCustomerData((prevForm: any) => ({
      ...prevForm,
      [id]: value.replace(/\D/g, ""),
    }));
    setValueClean(value.replace(/\D/g, ""))

    setIsInvalid((prevForm: any) => ({
      ...prevForm,
      [id]: false
    }));

    setShowModal(false)

    setMaskedValue(value)
  }

  const handleBlur = () => {
    if (id == 'JURÍDICA' && valueClean.length != 14) { setIsInvalid((prevForm: any) => ({ ...prevForm, cnpj: true })); }
    if (id == 'FÍSICA' && valueClean.length != 11) { setIsInvalid((prevForm: any) => ({ ...prevForm, cnpj: true })); }
  }

  const typePerson = () => {
    switch (id) {
      case "FÍSICA":
        setLabel(<label>Informe CPF do <b>Cliente</b></label>)
        setMasked("___.___.___-__")
        setInvalidFeedBack("Insira Um CPF Valido")
        if (valueClean.length == 11) {
          search()
        }
        if (!maskedValue) {
          const options = {
            mask: "___.___.___-__",
            replacement: { _: /\d/ },
          };
          const defaultValue = format(value, options);
          setMaskedValue(defaultValue)
        }
        break;

      case "JURÍDICA":
        setLabel(<label>Informe CNPJ do <b>Cliente</b></label>)
        setMasked("__.___.___/____-__")
        setInvalidFeedBack("Insira Um CNPJ Valido")
        if (valueClean.length == 14) {
          search()
        }
        if (!maskedValue) {
          const options = {
            mask: "__.___.___/____-__",
            replacement: { _: /\d/ },
          };
          const defaultValue = format(value, options);
          setMaskedValue(defaultValue)
        }
        break;

      case "stranger":
        setLabel(<label>Informe Documento do <b>Cliente</b></label>)
        setMasked("")
        setMaskedValue(value)

        break;
    }
  }

  const search = async () => {
    try {
      setLoading(true)
      await api.get(BackEndRoutes.routes.CLIENTES.FIND.replace(":cnpj", valueClean))
        .then((response: any) => {
          if (response.data.cnpj == valueClean) {
            console.log(response.data)
            setShowModal(true)
            setInvalidFeedBack('Cliente já Existe')
            setIsInvalid((prevForm: any) => ({
              ...prevForm,
              cnpj: true
            }));
          }
        })
        .finally(() => setLoading(false))
    } catch (error) {
      console.error("Erro ao buscar o cliente", error);
    }
  }

  useEffect(() => {
    typePerson()
    if (!value) {
      setMaskedValue(value)
    }

  }, [id, value])

  return (
    <div className="col-md-6 col-lg-4">
      {label}
      <div className="input-group">
        <button type="button" style={{ borderRadius: "5px 0px 0px 5px" }} className={`btn btn-outline-secondary dropdown-toggle dropdown-toggle-split ${id == 'JURÍDICA' ? '' : 'd-none'}`} data-bs-toggle="dropdown" aria-expanded="false">
          <span className="visually-hidden">Toggle Dropdown</span>
        </button>
        <InputMask
          style={id == "JURÍDICA" ? { borderRadius: "0px 5px 5px 0px" } : { borderRadius: "6px" }}
          id="cnpj"
          className={className}
          type="text"
          value={maskedValue}
          replacement={{ _: /\d/ }}
          onChange={handleChange}
          mask={masked}
          placeholder={masked}
          onBlur={handleBlur}
          disabled={disable}
        />
        <p className="invalid-feedback">
          {invalidFeedBack}
        </p>
      </div>
    </div>
  )
}

export default InputPfPj